import { call, put, take, takeEvery, select } from 'redux-saga/effects'
import { MA, SA } from '@prohabits/metaverse'
import { LOCATION_CHANGE } from 'connected-react-router'
// TODO: @Serginyo90 check current methods
// @ts-ignore
import { stopAsyncValidation, submit } from 'redux-form/immutable'

import * as REQUESTS from 'app/constants/requests'
import {
  fetchAllSuccess,
  setFormType,
  updateOrganizationUserRoles,
  deleteOrganizationUserRole,
} from 'store/entities/organizations/actions'
import * as types from 'store/entities/organizations/actionTypes'
import { ORGANIZATIONS_EDIT_FORM_NAME } from 'app/constants/organizations'
import makeAPIRequest, { getResponseBody, getResponseData } from 'store/entities/api/sagas'
import { MICROACTIONS_PATH } from 'app/constants/navLinks'
import { getIdentityOrganizationId, isSuperAdmin, isSuperOrMultiAdmin } from 'store/entities/identity/selectors'

export default function* organizationsFlow() {
  while (true) {
    const request = yield take([
      types.ORGANIZATIONS_FETCH_ALL_REQUEST,
      updateOrganizationUserRoles.success.toString(),
      deleteOrganizationUserRole.success.toString(),
      LOCATION_CHANGE,
      types.ORGANIZATIONS_REMOTE_FORM_SUBMIT,
    ])

    yield call(runOrganizationsRequest, request)
  }
}

export function* checkDomainRequestSaga() {
  yield takeEvery(types.ORGANIZATIONS_CHECK_DOMAIN_REQUEST, checkDomainRequest)
}

function* checkDomainRequest({ payload: { domain, formName } }: any) {
  try {
    const response = yield call(makeAPIRequest, `/organizations/domain-check/${domain}`, {
      method: REQUESTS.GET,
    })
    const { data } = response.data
    if (data && data.available === false) {
      yield put(stopAsyncValidation(formName, { domain: 's' }))
    }
  } catch (badResponse) {
    throw new Error(badResponse)
  }
}

export function* runOrganizationsRequest(request: any) {
  const isSAOrMA = yield select(isSuperOrMultiAdmin)
  switch (request.type) {
    case types.ORGANIZATIONS_FETCH_ALL_REQUEST:
    case updateOrganizationUserRoles.success.toString():
    case deleteOrganizationUserRole.success.toString():
      if (isSAOrMA) {
        return yield call(fetchAllFlow)
      }
      return
    case LOCATION_CHANGE:
      return yield call(organizationsFormFlow, request.payload.location.pathname)
    case types.ORGANIZATIONS_REMOTE_FORM_SUBMIT:
      return yield call(organizationsRemoteSubmitFlow)
    default:
      return null
  }
}

const isOrganizationsCreateFormPathname = (pathname: string) => pathname === `${MICROACTIONS_PATH}/organizations/create`

const isOrganizationsEditFormPathname = (pathname: string) =>
  /^\/microactions\/organizations\/.{1,}\/edit$/i.test(pathname)

const isOrganizationsFormPathname = (pathname: string) =>
  isOrganizationsCreateFormPathname(pathname) || isOrganizationsEditFormPathname(pathname)

export function* organizationsFormFlow(pathname: string) {
  if (isOrganizationsFormPathname(pathname)) {
    if (isOrganizationsCreateFormPathname(pathname)) {
      yield put(setFormType('create'))
    } else {
      yield put(setFormType('edit'))
    }
  }
}

// this flow will fire after click "Ok" button in confirmation modal, so the selectedProtracks is empty
export function* organizationsRemoteSubmitFlow() {
  yield put(submit(ORGANIZATIONS_EDIT_FORM_NAME))
}

function* fetchAllFlow() {
  const isSA = yield select(isSuperAdmin)
  const organizationId = yield select(getIdentityOrganizationId)
  const response = yield call(makeAPIRequest, `/organizations/${isSA ? SA : `${MA}/${organizationId}`}`, {
    method: REQUESTS.GET,
  })

  const body = yield call(getResponseBody, response)

  const data = yield call(getResponseData, body)

  yield put(fetchAllSuccess(data))
}
